import React from 'react';
import {Dropdown, DropdownOptionProps} from 'wix-ui-tpa/cssVars';
import {useControllerProps} from '../../Widget/ControllerContext';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {getCountryFromLocaleDataset} from '../../../../domain/utils/localeDataset.util';
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor';
import {classes} from './SubdivisionSelector.st.css';
import type {Country} from '@wix/locale-dataset-data';
import {SPECS} from '../../../../common/constants';

export enum SubdivisionSelectorDataHook {
  dropdown = 'SubdivisionSelector.dropdown',
}
export const SubdivisionSelector = () => {
  const localeKeys = useLocaleKeys();
  const {t} = useTranslation();
  const {experiments} = useExperiments();
  const {
    checkoutStore: {cart, setSubdivision},
  } = useControllerProps();
  const address = cart.hasShippableItems ? cart.deliveryInfo.address : cart.paymentInfo.address;
  const countryOptions: Country = getCountryFromLocaleDataset(
    address?.country as string,
    experiments.enabled(SPECS.UseLocalDatasetDirectlyInCheckout)
  );
  const subdivisionsOptions =
    countryOptions?.subdivisions?.list.map((subdivision) => ({
      id: `${countryOptions.shortKey!}-${subdivision.key}`,
      value: t(subdivision.displayName),
      isSelectable: true,
    })) ?? /* istanbul ignore next */ [];

  const onSubdivisionSelect = (selectedOption: DropdownOptionProps) => {
    void setSubdivision(selectedOption.id as string);
  };

  return (
    <Dropdown
      data-hook={SubdivisionSelectorDataHook.dropdown}
      className={classes.subdivision}
      options={subdivisionsOptions}
      upgrade={true}
      onChange={onSubdivisionSelect}
      label={localeKeys.checkout.place_order_fast_flow.region_select_title({
        subdivision: t(countryOptions?.subdivisions?.displayName ?? /* istanbul ignore next */ ''),
      })}
    />
  );
};
